import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`The environement (Kubernetes, Applications, …) create logs that are being fed into a Log Management Tool (ELK in this case).`}</p>
    <img {...{
      "src": "./../images/waiops_arch_overview.jpg",
      "alt": "demo"
    }}></img>
    <ol>
      <li parentName="ol">{`External Systems generate Alerts and send them into the CP4AIOPS for Event Grouping.`}</li>
      <li parentName="ol">{`At the same time CP4AIOPS ingests the raw logs coming from the Log Management Tool (ELK) and looks for anomalies in the stream based on the trained model.`}</li>
      <li parentName="ol">{`It also ingests Metric Data and looks for anomalies`}</li>
      <li parentName="ol">{`If it finds an anomaly (logs and/or metrics) it forwards it to the Event Grouping as well.`}</li>
      <li parentName="ol">{`Out of this, CP4AIOPS creates a Story that is being enriched with Topology (Localization and Blast Radius) and with Similar Incidents that might help correct the problem.`}</li>
      <li parentName="ol">{`The Story is then sent to Slack.`}</li>
      <li parentName="ol">{`A Runbook is available to correct the problem but not launched automatically.`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      